import TagGroupDetail from './TagGroupDetail/index';
import TagGroupDetailItem from './TagGroupDetail/TagGroupDetailItem/index';
import TagGroupDetailLinkSku from './TagGroupDetail/TagGroupDetailLinkSku/index';

export default {
  TagGroupDetail,
  TagGroupDetailItem,
  TagGroupDetailLinkSku,
}